/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddProgram = () => {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        benefits: '',
        eligibility: '',
        guidelines: '',
        image: null
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.title || !formData.description) {
            toast.error("Title and Description are required!");
            return;
        }

        setLoading(true);
        const data = new FormData();
        for (const key in formData) {
            if (formData[key] !== null) {
                data.append(key, formData[key]);
            }
        }

        try {
            await postRequest('programs', data);
            toast.success('Program added successfully!');
            navigate('/programs');
        } catch (error) {
            console.error('Failed to add program:', error);
            toast.error(error?.message || 'Error occurred while creating program.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className='container-fluid mt-5 mb-5'>
                <div className='mainheadig mx-4 mb-4'>
                    <h4 className='text-white font-weight-bold'>Add Incubation Program</h4>
                </div>
                <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                    <div className='row'>
                        <div className='col-sm-12 form-group'>
                            <label className='admin-label font-weight-bold'>Program Title *</label>
                            <input
                                type='text'
                                name='title'
                                className='form-control'
                                value={formData.title}
                                onChange={handleChange}
                                placeholder="e.g. SAAKAR Program"
                                required
                            />
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Description *</label>
                            <textarea
                                name='description'
                                className='form-control'
                                rows="4"
                                value={formData.description}
                                onChange={handleChange}
                                placeholder="Write program description here..."
                                required
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Program Benefits</label>
                            <textarea
                                name='benefits'
                                className='form-control'
                                rows="3"
                                value={formData.benefits}
                                onChange={handleChange}
                                placeholder="What benefits do startups get?"
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Eligibility Criteria</label>
                            <textarea
                                name='eligibility'
                                className='form-control'
                                rows="3"
                                value={formData.eligibility}
                                onChange={handleChange}
                                placeholder="Who is eligible to apply?"
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Application Guidelines</label>
                            <textarea
                                name='guidelines'
                                className='form-control'
                                rows="3"
                                value={formData.guidelines}
                                onChange={handleChange}
                                placeholder="Steps to apply..."
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Cover Image</label>
                            <input
                                type='file'
                                name='image'
                                className='form-control filebg'
                                onChange={handleChange}
                                accept="image/*"
                            />
                        </div>
                    </div>
                    
                    <div className='mt-4 text-right'>
                        <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={() => navigate('/programs')}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className='btn addbtn pl-4 pr-4'
                            disabled={loading}
                        >
                            {loading ? 'Creating...' : 'Add Program'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddProgram;
